import { SystemFuncArgs } from '@brochington/ecstatic';
import { getSheetToScreenTransform } from 'editor/utils/transform';
import { Components } from '../components';
import Markup from '../components/Markup';
import MarkupKit from '../components/MarkupKit';
import Overlay from '../components/Overlay';

export const renderMarkupComponents = [MarkupKit, Markup, Overlay];

export function renderMarkup(args: SystemFuncArgs<Components>): void {
  const { world, components } = args;
  const markupComp = components.get(Markup);
  const overlayComp = components.get(Overlay);
  const { MKMarkup, mkRenderMarkup } = components.get(MarkupKit);

  const { ctx } = overlayComp;
  // Create MKMarkup if not already created.
  if (!markupComp.mkMarkup) {
    markupComp.mkMarkup = new MKMarkup(markupComp.markup.jsonBlob);
  }

  if (!markupComp.hidden) {
    ctx.save();

    const transform = getSheetToScreenTransform(world);
    ctx.transform(...transform);

    mkRenderMarkup(markupComp.mkMarkup, ctx, new Map());
    ctx.restore();
  }

  if (markupComp.selected) {
    const markupType = markupComp.mkMarkup.getType();

    // Draw dashed bbox if markup is selected.
    // NOTE: Might be good to build this out in a separate System.
    if (
      markupType === 'Square' ||
      markupType === 'FreeText' ||
      markupComp.isPunch ||
      markupComp.isNewPunch
    ) {
      const bbox = markupComp.mkMarkup.getBBox();

      ctx.save();

      const transform = getSheetToScreenTransform(world);
      ctx.transform(...transform);

      ctx.strokeStyle = 'blue';
      ctx.lineWidth = 2;
      ctx.setLineDash([4]);

      ctx.strokeRect(
        bbox.left - 4,
        bbox.bottom - 4,
        bbox.right - bbox.left + 8,
        bbox.top - bbox.bottom + 8
      );

      ctx.restore();
    }
  }
}
